<div
  #accordionCardElement
  class="flex flex-col rounded-[12px] bg-neutrals-0 border-neutrals-300 box-border p-5"
>
  <div class="flex justify-between items-center">
    <ui-headline
      type="h14"
      mobile-type="h14"
      font-weight="semibold"
      text-color="neutrals-700"
    >
      {{ title }}
    </ui-headline>

    <button type="button" #toggleButton (click)="toggle()">
      <ui-icon name="chevron-up" fill="neutrals-600" m-size="24" size="24" />
    </button>
  </div>
  <div class="box-border overflow-hidden" #toggleElement>
    <ng-content></ng-content>
  </div>
</div>
